import React from 'react';
import {useTranslation} from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import {Link} from "react-router-dom";
import {isComponentVisibleForUser, isComponentEnabledForUser} from 'utils';
import Info from '@material-ui/icons/Info';
import Tooltip from '@material-ui/core/Tooltip';
import ProductAdminIcon from '@material-ui/icons/DescriptionOutlined';
import AppsIcon from '@material-ui/icons/Apps';
import IconButton from '@material-ui/core/IconButton';
import DevicesIcon from '@material-ui/icons/Devices';
import ParkingSymbol from "../../components/common/ParkingSymbol";
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import GroupIcon from '@material-ui/icons/Group';
import SwitchVideo from '@material-ui/icons/SwitchVideo';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(3.75),
    },
    title: {
        cursor: 'pointer',
    },
    list: {
        display: 'flex',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
    },
    item: {
        width: 370,
        height: 200,
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        marginRight: theme.spacing(2.5),
        marginBottom: theme.spacing(2.5),
        backgroundColor: theme.palette.background.paper,
        borderRadius: 4,
        boxShadow: theme.palette.shadow.main,
        cursor: 'pointer',
    },
    titleWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 160,
        //margin: theme.spacing(2.5, 3.75, 3.75, 0),
    },
    itemToolBar: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 40,
        width: '100%',
        padding: theme.spacing(2.5),
        backgroundColor: "#F0F0F0",

    },
    itemTitle: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
    },
    link: {
        textDecoration: 'none',
        color: theme.palette.base[600],
    },
}));

function AdministrationList(props) {
    const classes = useStyles();
    const {t} = useTranslation();

    const {
        userUseCases,
    } = props;

    return (
        <div className={classes.container}>
            <div className={classes.list}>
                <div className={classes.item}>
                    <Link to={isComponentEnabledForUser(UC_PRODUCT_ADMINISTRATION, userUseCases) ? `/${process.env.REACT_APP_PATH}/administration/products` : "#"}
                          className={classes.link}>
                        <div className={classes.titleWrapper}>
                            <div className={classes.itemTitle}>
                                <IconButton color="secondary" aria-label="Set up products">
                                    <AppsIcon color="secondary" style={{ fontSize: 65 }} />
                                </IconButton>
                                <Typography variant="h3">{t('PRODUCT_ADMINISTRATION')}</Typography>

                            </div>
                        </div>
                    </Link>
                    <div className={classes.itemToolBar}>
                        <Tooltip title={t('PRODUCT_ADMINISTRATION_DESCRIPTION')}><div><Info color="secondary" /></div></Tooltip>
                    </div>
                </div>
                <div className={classes.item}>
                    <Link to={isComponentEnabledForUser(UC_PARKING_CONFIGURATION, userUseCases) ? `/${process.env.REACT_APP_PATH}/administration/parkings` : "#"}
                          className={classes.link}>
                        <div className={classes.titleWrapper}>
                            <div className={classes.itemTitle}>
                                <IconButton color="secondary" aria-label="Set up parkings">
                                <ParkingSymbol
                                    color="#5985EE"
                                />
                                </IconButton>
                                <Typography variant="h3">{t('PARKING_CONFIGURATION')}</Typography>

                            </div>
                        </div>
                    </Link>
                    <div className={classes.itemToolBar}>
                        <Tooltip title={t('PARKING_CONFIGURATION_DESCRIPTION')}><div><Info color="secondary" /></div></Tooltip>
                    </div>
                </div>
                <div className={classes.item}>
                    <Link to={isComponentEnabledForUser(UC_POS_CONFIGURATION, userUseCases) ? `/${process.env.REACT_APP_PATH}/administration/poslist` : "#"}
                          className={classes.link}>
                        <div className={classes.titleWrapper}>
                            <div className={classes.itemTitle}>
                                <IconButton color="secondary" aria-label="Set up parkings">
                                    <DevicesIcon color="secondary" style={{ fontSize: 65 }} />
                                </IconButton>
                                <Typography variant="h3">{t('POS_CONFIGURATION')}</Typography>

                            </div>
                        </div>
                    </Link>
                    <div className={classes.itemToolBar}>
                        <Tooltip title={t('POS_CONFIGURATION_DESCRIPTION')}><div><Info color="secondary" /></div></Tooltip>
                    </div>
                </div>

                <div className={classes.item}>
                     <Link to={isComponentEnabledForUser(UC_ROLE_ADMINISTRATION, userUseCases) ? `/${process.env.REACT_APP_PATH}/administration/rolelist` : "#"}
                          className={classes.link}>
                        <div className={classes.titleWrapper}>
                            <div className={classes.itemTitle}>
                                <IconButton color="secondary" aria-label="Set up parkings">
                                    <GroupIcon color="secondary" style={{ fontSize: 65 }} />
                                </IconButton>
                                <Typography variant="h3">{t('ROLE_ADMINISTRATION')}</Typography>

                            </div>
                        </div>
                    </Link>
                    <div className={classes.itemToolBar}>
                        <Tooltip title={t('ROLE_ADMINISTRATION_DESCRIPTION')}><div><Info color="secondary" /></div></Tooltip>
                    </div>
                </div>
                <div className={classes.item}>
                    <Link to={isComponentEnabledForUser(UC_USER_ADMINISTRATION, userUseCases) ? `/${process.env.REACT_APP_PATH}/administration/userlist` : "#"}
                          className={classes.link}>
                        <div className={classes.titleWrapper}>
                            <div className={classes.itemTitle}>
                                <IconButton color="secondary" aria-label="Set up parkings">
                                    <PersonOutlineIcon color="secondary" style={{ fontSize: 65 }} />
                                </IconButton>
                                <Typography variant="h3">{t('USER_ADMINISTRATION')}</Typography>

                            </div>
                        </div>
                    </Link>
                    <div className={classes.itemToolBar}>
                        <Tooltip title={t('USER_ADMINISTRATION_DESCRIPTION')}><div><Info color="secondary" /></div></Tooltip>
                    </div>
                </div>

                <div className={classes.item}>
                     <Link to={isComponentEnabledForUser(UC_EXT_ROLE_ADMINISTRATION, userUseCases) ? `/${process.env.REACT_APP_PATH}/administration/extrolelist` : "#"}
                          className={classes.link}>
                        <div className={classes.titleWrapper}>
                            <div className={classes.itemTitle}>
                                <IconButton color="secondary" aria-label="Set up parkings">
                                    <GroupIcon color="secondary" style={{ fontSize: 65 }} />
                                </IconButton>
                                <Typography variant="h3">{t('EXT_ROLE_ADMINISTRATION')}</Typography>

                            </div>
                        </div>
                    </Link>
                    <div className={classes.itemToolBar}>
                        <Tooltip title={t('EXT_ROLE_ADMINISTRATION_DESCRIPTION')}><div><Info color="secondary" /></div></Tooltip>
                    </div>
                </div>
                <div className={classes.item}>
                    <Link to={isComponentEnabledForUser(UC_EXT_USER_ADMINISTRATION, userUseCases) ? `/${process.env.REACT_APP_PATH}/administration/extuserlist` : "#"}
                          className={classes.link}>
                        <div className={classes.titleWrapper}>
                            <div className={classes.itemTitle}>
                                <IconButton color="secondary" aria-label="Set up parkings">
                                    <PersonOutlineIcon color="secondary" style={{ fontSize: 65 }} />
                                </IconButton>
                                <Typography variant="h3">{t('EXT_USER_ADMINISTRATION')}</Typography>

                            </div>
                        </div>
                    </Link>
                    <div className={classes.itemToolBar}>
                        <Tooltip title={t('EXT_USER_ADMINISTRATION_DESCRIPTION')}><div><Info color="secondary" /></div></Tooltip>
                    </div>
                </div>

                <div className={classes.item}>
                    <Link to={isComponentEnabledForUser(UC_PLAY_LIST_ADMINISTRATION, userUseCases) ? `/${process.env.REACT_APP_PATH}/administration/playlist` : "#"}
                          className={classes.link}>
                        <div className={classes.titleWrapper}>
                            <div className={classes.itemTitle}>
                                <IconButton color="secondary" aria-label="Set up parkings">
                                    <SwitchVideo color="secondary" style={{ fontSize: 65 }} />
                                </IconButton>
                                <Typography variant="h3">{t('PLAY_LIST')}</Typography>

                            </div>
                        </div>
                    </Link>
                    <div className={classes.itemToolBar}>
                        <Tooltip title={t('PLAY_LIST_ADMINISTRATION_DESCRIPTION')}><div><Info color="secondary" /></div></Tooltip>
                    </div>
                </div>
                <div className={classes.item}>
                    <Link to={isComponentEnabledForUser(UC_INFO_BAR_ADMINISTRATION, userUseCases) ? `/${process.env.REACT_APP_PATH}/administration/infobar` : "#"}
                          className={classes.link}>
                        <div className={classes.titleWrapper}>
                            <div className={classes.itemTitle}>
                                <IconButton color="secondary" aria-label="Set up parkings">
                                    <OpenInBrowserIcon color="secondary" style={{ fontSize: 65 }} />
                                </IconButton>
                                <Typography variant="h3">{t('INFO_BAR')}</Typography>

                            </div>
                        </div>
                    </Link>
                    <div className={classes.itemToolBar}>
                        <Tooltip title={t('INFO_BAR_DESCRIPTION')}><div><Info color="secondary" /></div></Tooltip>
                    </div>
                </div>
            </div>
        </div>
    );
}

AdministrationList.propTypes = {};

const UC_PRODUCT_ADMINISTRATION = 'UC0610';
const UC_PARKING_CONFIGURATION = 'UC0630';
const UC_POS_CONFIGURATION = 'UC0640';
const UC_ROLE_ADMINISTRATION = 'UC0650';
const UC_USER_ADMINISTRATION = 'UC0660';
const UC_PLAY_LIST_ADMINISTRATION = 'UC0670';
const UC_INFO_BAR_ADMINISTRATION = 'UC0680';
const UC_EXT_ROLE_ADMINISTRATION = 'UC0686';
const UC_EXT_USER_ADMINISTRATION = 'UC0693';

export default AdministrationList;

